// extracted by mini-css-extract-plugin
export default {"paymentDisclaimer":"styles_paymentDisclaimer__xex8p"};